import TUIChat from './TUIChat';
import Component from './component';
import time from './time';
import AIDesk from './aidesk';

const messages = {
  id: {
    "取消": 'Batal',
    "确定": 'Sahkan',
    "发送": 'Kirim',
    "系统通知": 'Pemberitahuan Sistem',
    "关闭": 'Tutup',
    "图片": 'Gambar',
    "文件": 'Berkas',
    "表情": 'wajah',
    "视频": 'rekaman video',
    "录制": 'Merekam',
    "拍照": 'Memotret',
    AIDesk,
    TUIChat,
    Component,
    time,
  },
};

export default messages;